import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { empresaAction, tipoServicoAction, tipoVeiculoAction, estadoAction } from '../../_actions'
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  Button,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import {
  ValidatorForm
} from 'react-material-ui-form-validator'
import { ContextFiltrosEmpresa } from '../../contexts/ContextFiltrosEmpresas';

export const EmpresaModalFiltros = ({ modal, toggle, props, page, limit, idOrgao, order, direction }) => {

  const formRef = React.createRef(null);

  const dispatch = useDispatch()
  const { classes, className, ...rest } = props
  const { match: { params } } = props;
  const { status,
    setStatus,
    state,
    setState,
    typeVehicle,
    setTypeVehicle,
    typeService,
    setTypeService,
    handleClearFilters
  } = useContext(ContextFiltrosEmpresa);

  useEffect(() => {
    dispatch(tipoServicoAction.getTiposServicoSelect())
    dispatch(tipoVeiculoAction.getTipoVeiculoSelect())
    dispatch(estadoAction.getEstadoSelect())
  }, [])

  const { tipoVeiculo } = useSelector(
    (state) => state.tipoVeiculo
  )

  const { tipoServico } = useSelector(
    (state) => state.tipoServico
  )

  const { estado } = useSelector(
    (state) => state.estado
  )

  const handleClose = () => {
    toggle();
  }

  const handleApplyFilters = () => {
    let filterModel = {
      Page: page ?? 0,
      Limit: limit ?? 10,
      Order: order || 'nome',
      Direction: direction || 'ASC',
      Status: status?.value || '',
      IdOrgao: idOrgao || '',
      TiposVeiculos: (typeVehicle?.map(s => s.value).join(',')) || '',
      TiposServicos: (typeService?.map(s => s.value).join(',')) || '',
      Estados: (state?.map(s => s.value).join(',')) || ''
    };

    dispatch(empresaAction.getEmpresa(filterModel, true));
    toggle();
  };

  const handleChangeTiposServicos = (value) => {
    setTypeService(value);
  };

  const handleChangeEstados = (value) => {
    setState(value);
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  const handleChangeTiposVeiculos = (value) => {
    setTypeVehicle(value);
  };

  function InsertText() {
    return (
      <Typography variant="h6">
        <b>{'Filtros'}</b>
      </Typography>
    )
  }

  function SegHeader() {
    return <InsertText />
  }

  return (
    <Dialog
      open={modal}
      fullWidth
      style={{ padding: 0, margin: 0 }}
      maxWidth='md'
      onClose={toggle}
    >
      <DialogTitle align="right" style={{ paddingTop: 0, marginTop: 0, marginBottom: 0, paddingBottom: 0 }}>
        <Button
          variant="contained"
          style={{ backgroundColor: '#000', position: 'relative', marginTop: 15 }}
          onClick={() => handleClose()}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginTop: 0 }}>
          <ValidatorForm
            style={{ marginTop: 0, paddingTop: 0 }}
            ref={formRef}
            id="formUsuario"
            //onSubmit={(event) => handleApplyFilters(event)}
          >
            <CardHeader
              style={{ marginTop: 0, paddingTop: 0 }}
              subheader="Selecionar filtros para aplicar à listagem de Ordens de Serviços"
              title={<SegHeader />}
            />
            <Divider />
            <CardContent>
              <Grid container>
                <Grid item xl={12} lg={12} md={12} xs={12} align="left" style={{ marginTop: 10 }}>
                  <Autocomplete
                    multiple
                    id="tiposVeiculos"
                    value={typeVehicle}
                    className={classes.textField}
                    margin="normal"
                    options={tipoVeiculo}
                    getOptionLabel={(option) => option.text}
                    onChange={(event, value) => handleChangeTiposVeiculos(value)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.textField}
                        variant="outlined"
                        label="Selecione o(s) tipo(s) de veículo(s)"
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={12} lg={12} md={12} xs={12} align="left" style={{ marginTop: 10 }}>
                  <Autocomplete
                    multiple
                    id="tiposServicos"
                    className={classes.textField}
                    value={typeService}
                    margin="normal"
                    options={tipoServico}
                    getOptionLabel={(option) => option.text}
                    onChange={(event, value) => handleChangeTiposServicos(value)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        className={classes.textField}
                        label="Selecione o(s) tipo(s) de serviço(s)"
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={12} lg={12} md={12} xs={12} align="left" style={{ marginTop: 10 }}>
                  <Autocomplete
                    multiple
                    id="estados"
                    value={state}
                    options={estado}
                    getOptionLabel={(option) => option.text}
                    onChange={(event, value) => handleChangeEstados(value)}
                    fullWidth
                    margin="normal"
                    className={classes.textField}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.textField}
                        variant="outlined"
                        label="Selecione o(s) estado(s)"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid container style={{
                display: 'flex',
                alignItems: 'end',
                flexDirection: 'row',
                textAlign: 'end',
                justifyContent: 'end'
              }}>
                {/*<Button
                  variant="outlined"
                  style={{ color: '#000', borderColor: '#000' }}
                  onClick={toggle}
                >
                  Cancelar
                </Button>*/}
                <Button
                  variant="outlined"
                  style={{ color: '#000', borderColor: '#000' }}
                  onClick={handleClearFilters}
                >
                  Limpar filtros
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{ backgroundColor: '#000' }}
                  disabled={props.empresa.isLoading}
                  startIcon={<SearchIcon />}
                  endIcon={props.empresa.isLoading && <CircularProgress size={24} />}
                  onClick={ ()=> handleApplyFilters() }
                >
                  {props.empresa.isLoading ? 'Pesquisando...' : 'OK'}
                </Button>
              </Grid>
            </CardActions>
          </ValidatorForm>
        </Card>
      </DialogContent>
    </Dialog >
  )
}
